import React, { useState } from 'react';
const DELI_ITEMS = [
  { id: 1, name: 'Smoked Turkey Breast', type: 'Sliced', price: '$14.99/lb', prepared: 12, status: 'In Stock' },
  { id: 2, name: 'Black Forest Ham', type: 'Sliced', price: '$12.99/lb', prepared: 8, status: 'In Stock' },
  { id: 3, name: 'Chicken Caesar Wrap', type: 'Prepared', price: '$8.99', prepared: 15, status: 'In Stock' },
  { id: 4, name: 'Potato Salad 1lb', type: 'Salad', price: '$6.99', prepared: 6, status: 'Low' },
  { id: 5, name: 'Italian Sub Combo', type: 'Sandwich', price: '$10.99', prepared: 0, status: 'Made to Order' },
  { id: 6, name: 'Rotisserie Chicken', type: 'Hot', price: '$12.99', prepared: 4, status: 'Low' },
];
export default function DeliCounterPage() {
  const [filter, setFilter] = useState('All');
  const types = ['All', ...new Set(DELI_ITEMS.map(d => d.type))];
  const filtered = DELI_ITEMS.filter(d => filter === 'All' || d.type === filter);
  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div><h1 style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Deli Counter</h1><p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>Deli prep, slicing orders, and prepared foods</p></div>
        <button style={{ padding: '10px 20px', background: 'var(--primary)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>+ Prep Order</button>
      </div>
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, flexWrap: 'wrap' }}>
        {types.map(t => (
          <button key={t} onClick={() => setFilter(t)} style={{ padding: '8px 16px', background: filter === t ? 'var(--primary)' : 'var(--card)', color: filter === t ? '#fff' : 'var(--text-secondary)', border: '1px solid var(--border)', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{t}</button>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 12 }}>
        {filtered.map(item => (
          <div key={item.id} style={{ padding: 20, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
              <div><div style={{ color: 'var(--text)', fontSize: 14, fontWeight: 600 }}>{item.name}</div><div style={{ color: 'var(--text-muted)', fontSize: 12 }}>{item.type} &middot; {item.price}</div></div>
              <span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: item.status === 'In Stock' ? '#16A34A20' : item.status === 'Low' ? '#F59E0B20' : '#3B82F620', color: item.status === 'In Stock' ? '#16A34A' : item.status === 'Low' ? '#F59E0B' : '#3B82F6' }}>{item.status}</span>
            </div>
            <div style={{ color: 'var(--text-secondary)', fontSize: 13 }}>Prepared: <strong>{item.prepared}</strong> units</div>
          </div>
        ))}
      </div>
    </div>
  );
}
